import * as React from "react";
import { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgMapMarkerMdc = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" width="1em" height="1em" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M16 0c6.377 0 11.112 4.811 11.189 11.188-.42 4.583-2.33 9.089-5.614 13.595C18.33 29.213 16.458 31.618 16 32c-.458-.382-2.367-2.75-5.651-7.217-3.246-4.468-5.117-9.012-5.538-13.595C4.888 4.812 9.623 0 16 0zm0 15.16c2.33 0 3.971-1.642 3.971-3.971 0-2.33-1.642-3.972-3.971-3.972-2.33 0-3.971 1.642-3.971 3.972 0 2.329 1.642 3.97 3.971 3.97z" /></svg>;
export default SvgMapMarkerMdc;